import { MutableRefObject } from 'react';

// Scroll lock utilities for Safari mobile and desktop
export function lockScroll(scrollPositionRef: MutableRefObject<number>) {
  if (typeof window === 'undefined') return;

  // Save current scroll position
  scrollPositionRef.current = window.pageYOffset || document.documentElement.scrollTop;

  // Prevent touch move on document (for mobile)
  const preventTouchMove = (e: TouchEvent) => {
    // Allow scrolling inside driver popover
    const target = e.target as HTMLElement;
    if (target?.closest('.driver-popover')) {
      return;
    }
    e.preventDefault();
  };

  // Prevent wheel scrolling (for desktop)
  const preventWheel = (e: WheelEvent) => {
    // Allow scrolling inside driver popover
    const target = e.target as HTMLElement;
    if (target?.closest('.driver-popover')) {
      return;
    }
    e.preventDefault();
  };

  // Prevent keyboard scrolling (arrow keys, page up/down, space)
  const preventKeyScroll = (e: KeyboardEvent) => {
    const keys = [
      'ArrowUp',
      'ArrowDown',
      'ArrowLeft',
      'ArrowRight',
      'PageUp',
      'PageDown',
      'Home',
      'End',
      ' ',
    ];
    if (keys.includes(e.key)) {
      // Allow if inside popover
      const target = e.target as HTMLElement;
      if (target?.closest('.driver-popover')) {
        return;
      }
      e.preventDefault();
    }
  };

  document.addEventListener('touchmove', preventTouchMove, { passive: false });
  document.addEventListener('wheel', preventWheel, { passive: false });
  document.addEventListener('keydown', preventKeyScroll, { passive: false });

  (window as any).__preventTouchMove = preventTouchMove;
  (window as any).__preventWheel = preventWheel;
  (window as any).__preventKeyScroll = preventKeyScroll;
}

export function unlockScroll() {
  if (typeof window === 'undefined') return;

  // Remove all event listeners
  const preventTouchMove = (window as any).__preventTouchMove;
  const preventWheel = (window as any).__preventWheel;
  const preventKeyScroll = (window as any).__preventKeyScroll;

  if (preventTouchMove) {
    document.removeEventListener('touchmove', preventTouchMove);
    delete (window as any).__preventTouchMove;
  }

  if (preventWheel) {
    document.removeEventListener('wheel', preventWheel);
    delete (window as any).__preventWheel;
  }

  if (preventKeyScroll) {
    document.removeEventListener('keydown', preventKeyScroll);
    delete (window as any).__preventKeyScroll;
  }
}
